import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { CoverImg } from "@/components/ui/CoverImg";

interface P {
  to: string;
  coverId: string | null | undefined;
  title: string;
  subtitle?: string;
  round?: boolean;
  overlay?: ReactNode;
  onContextMenu?: (e: React.MouseEvent) => void;
}

export function MediaCard({ to, coverId, title, subtitle, round, overlay, onContextMenu }: P) {
  return (
    <Link to={to} className="card" data-sfx="tap" style={{ display: "block" }}
          onContextMenu={onContextMenu}>
      <div style={{ position: "relative" }}>
        <CoverImg
          coverId={coverId}
          alt={title}
          className={round ? "cover round" : "cover"}
        />
        {round && <style>{`.round{border-radius:50%}`}</style>}
        {overlay && <div style={{ position: "absolute", inset: 0 }}>{overlay}</div>}
      </div>
      <div style={{ marginTop: 10, fontWeight: 600 }} className="trunc">{title}</div>
      {subtitle && <div className="muted trunc" style={{ marginTop: 2 }}>{subtitle}</div>}
    </Link>
  );
}
